import React from "react";

class ValidationErrors extends React.PureComponent {

    render() {
        let errMessages = this.props.errorMessages;
        const defaultErrorMessageClass = "error-message";

        let errorMessageLine = (errMsg, index) => errMessages && <span key={index}>{errMsg}<br /> </span>;

        return <div className={this.props.className ? this.props.className : defaultErrorMessageClass}>
            {Array.isArray(errMessages) ?
                errMessages.map(errorMessageLine) :
                errorMessageLine(errMessages, 0)}
        </div>;
    }
}
export default ValidationErrors;
